var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"freestyle-container"},[_c('AudioControl'),_c('div',{staticClass:"freestyle-container--border"},[(_vm.slideActive.backgroundImage)?_c('div',{staticClass:"freestyle-container--background-wrapper",style:({
        'background-image': 'url(' + _vm.slideActive.backgroundImage.large + ')' ,
        'background-size': 'cover',
        opacity: _vm.slideActive.visibility / 100
      })}):_vm._e(),(_vm.slideActive.image)?_c('div',{staticClass:"freestyle-container--background-wrapper",style:({
        'background-image': 'url(' + _vm.slideActive.image.large + ')' ,
        'background-size': 'contain',
        'background-repeat': 'no-repeat',
        'background-position': 'center'

      })}):_vm._e(),_c('div',{staticClass:"freestyle-container--thumbnail-wrapper"},[_c('FreestyleThumbnailPreview',{attrs:{"slide":_vm.slideActive}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }